import React from 'react';
import SEO from '../components/SEO';

const ADAStatement = () => {
  return (
    <article
      aria-labelledby="accessibility-title"
      className="mx-auto w-full max-w-4xl px-6 py-24 font-mono text-xs uppercase leading-loose text-black"
    >
      <SEO
        title="Accessibility Statement"
        description="Read the Broadway Muses accessibility statement and learn how to report accessibility barriers."
        path="/ada-statement"
      />

      <header className="mb-16 border-b-8 border-black pb-4">
        <h1
          id="accessibility-title"
          className="break-words font-serif text-4xl font-black italic md:text-7xl"
        >
          Accessibility Statement
        </h1>
        <p className="mt-6 font-mono text-[10px] font-black uppercase tracking-widest">
          Updated{' '}
          <time dateTime="2025-02-21">
            February 21, 2025
          </time>
        </p>
      </header>

      <div className="space-y-12">
        <section
          aria-labelledby="accessibility-commitment"
          className="border-l-4 border-black pl-6"
        >
          <h2
            id="accessibility-commitment"
            className="mb-4 text-xl font-bold"
          >
            Our Commitment
          </h2>
          <p>
            Broadway Muses is committed to ensuring digital accessibility for
            people with disabilities. We are continually improving the user
            experience for everyone and applying the relevant accessibility
            standards.
          </p>
        </section>

        <section
          aria-labelledby="accessibility-status"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="accessibility-status" className="mb-4 text-xl font-bold">
            Conformance Status
          </h2>
          <p>
            The Web Content Accessibility Guidelines (WCAG) defines requirements
            for designers and developers to improve accessibility for people
            with disabilities. We strive to conform to WCAG 2.1 level AA.
          </p>
        </section>

        <section
          aria-labelledby="accessibility-feedback"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="accessibility-feedback" className="mb-4 text-xl font-bold">
            Feedback
          </h2>
          <p>
            We welcome your feedback on the accessibility of Broadway Muses.
            Please let us know if you encounter accessibility barriers by
            emailing{' '}
            <a
              href="mailto:broadwaymuses@gmail.com"
              className="underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
            >
              broadwaymuses@gmail.com
            </a>
            .
          </p>
        </section>
      </div>
    </article>
  );
};

export default ADAStatement;